export const gitCommit = '50603ca9'
